import setPassword from './setPassword';

export default setPassword;
